<template>
  <v-card
    elevation="2"
    color="background"
    class="d-flex flex-column"
    style="height: 100%"
  >
    <v-card-title>
      الاصناف
      <v-spacer></v-spacer>

      <DefaultDialog
        :showAddButton="isCanCreate"
        buttonText="اضافة"
        title="اضافة صنف"
        :openToEdit="openToEdit"
        editTitle="تعديل صنف"
        :openToView="openToView"
        viewTitle="عرض البيانات"
        @onCloseDialog="onCloseDialog"
      >
        <CategoryDetail
          slot-scope="{
            submitWithClose,
            submitWithNew,
            submitWithoutClose,
            closeDialog,
            isEdit,
            isView,
            isNew,
          }"
          :submitWithClose="submitWithClose"
          :submitWithNew="submitWithNew"
          :submitWithoutClose="submitWithoutClose"
          :setItemID="setItemID"
          :closeDialog="closeDialog"
          :afterSubmit="getData"
          :itemId="itemId"
          :isEdit="isEdit"
          :isView="isView"
          :isNew="isNew"
        />
      </DefaultDialog>
    </v-card-title>
    <v-card-text
      class="d-flex flex-column justify-space-between"
      style="flex: 1; min-height: 0"
    >
      <!-- Filters -->
      <v-row style="flex: 0">
        <v-col cols="12" class="d-flex">
          <languages-filter @change="changeLanguage" />
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="filters.categoryName"
            flat
            hide-details="auto"
            label="بحث"
            outlined
            prepend-inner-icon="mdi-magnify"
            solo
            dense
            class="mr-6"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- Grid -->
      <v-row class="mt-0" style="min-height: 0">
        <v-col cols="12" style="flex: auto; min-height: 0; height: 100%">
          <v-data-table
            class="elevation-1"
            :headers="headers"
            :items="category"
            :items-per-page="options.pageSize"
            :loading="$store.state.loading.show"
            :ripple="false"
            fixed-header
            hide-default-footer
            height="100%"
            style="height: 100%; overflow: auto"
            loading-text="جار التحميل..."
            no-data-text="لا يوجد"
          >
            <template v-slot:[`item.contentTypes`]="{ item }">
              <div v-if="item.contentTypes && item.contentTypes.length">
                <v-chip
                  v-for="(type, index) in item.contentTypes.slice(0, 4)"
                  :key="index"
                  class="ml-1 mb-1"
                  small
                >
                  {{ type.name }}
                </v-chip>
                <v-chip v-if="item.contentTypes.length > 4" class="ml-1" small>
                  +{{ item.contentTypes.slice(4).length }}
                </v-chip>
              </div>
              <div v-else-if="item.contentTypeLanguage?.name">
                <v-chip class="ml-1" small>
                  {{ item.contentTypeLanguage.name }}
                </v-chip>
              </div>
            </template>

            <template v-slot:[`item.controls`]="props">
              <template v-if="isCanRead">
                <v-btn
                  small
                  color="#78b200"
                  @click="viewRow(props.item)"
                  class="mr-1"
                >
                  <v-icon color="#fff">mdi-eye</v-icon>
                </v-btn>
              </template>

              <template v-if="isCanUpdate">
                <v-btn
                  small
                  color="#ffa000"
                  @click="editRow(props.item)"
                  class="mr-1"
                >
                  <v-icon color="#fff">mdi-pencil-outline</v-icon>
                </v-btn>
              </template>

              <template v-if="isCanDelete">
                <v-btn
                  small
                  color="pink"
                  @click="deleteRow(props.item)"
                  class="mr-1"
                >
                  <v-icon color="#fff">mdi-delete</v-icon>
                </v-btn>
              </template>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <!-- pagination -->
      <v-row class="mt-0" style="flex: 0">
        <v-col cols="12" class="d-flex justify-space-between align-center">
          <v-pagination
            v-model="options.pageIndex"
            :length="numberOfPages"
            total-visible="7"
          />
          <v-select
            v-model="options.pageSize"
            :items="[5, 10, 15, 20]"
            label="عدد الصفوف"
            solo
            dense
            hide-details
            item-color="white"
            class="flex-grow-0"
            style="width: 100px"
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import qs from 'qs';
import LanguagesFilter from '@/components/LanguagesFilter.vue';
import { selectedLanguage } from '@/config/config';
import DefaultDialog from '@/components/DefaultDialog.vue';
import CategoryDetail from './crud/CategoryDetail.vue';

import { mapActions } from 'vuex';
import { showSnackbarFailMessage } from '@/utls/snackbar';
import PermissionMixin from '@/mixins/PermissionMixin';
import { appPermissions } from '@/libs/auth/permissions/appPermissions';

const initFilters = {
  categoryName: '',
};

const initOptions = {
  pageIndex: 1,
  pageSize: 15,
  language: selectedLanguage,
  ...initFilters,
};

export default {
  components: {
    LanguagesFilter,
    CategoryDetail,
    DefaultDialog,
  },
  mixins: [PermissionMixin(appPermissions.category)],
  data() {
    return {
      sel: null,
      category: [],
      total: 0,
      headers: [
        { text: 'slug', value: 'slug' },
        { text: 'الأسم', value: 'language.name' },
        { text: 'الاب', value: 'parentLanguage.name' },
        // { text: 'الهيكلية', value: 'contentTypeLanguage.name' },
        { text: 'الهيكلية', value: 'contentTypes' },
        { text: '', value: 'controls', sortable: false },
      ],
      options: { ...initOptions },
      filters: { ...initFilters },
      // for view edit and detail
      // ------------------------
      openToEdit: false,
      openToView: false,
      itemId: null,
      // ------------------------
    };
  },
  computed: {
    skipPerPage() {
      return this.options.pageSize * (this.options.pageIndex - 1);
    },
    numberOfPages() {
      const pages = Math.ceil(this.total / this.options.pageSize) || 1;
      return pages;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('confirm', ['openConfirm']),
    deleteRow(item) {
      this.openConfirm({
        message: 'هل انت متأكد من حذف الصنف ؟',
        confirm: () => {
          return this.$http
            .delete('app/category/' + item.id, {})
            .then(() => {
              this.getData();
              return true;
            })
            .catch((error) => {
              showSnackbarFailMessage('حدث خطأ اثناء عملية الحذف');
              return false;
            });
        },
      });
    },
    onCloseDialog() {
      this.openToEdit = false;
      this.openToView = false;
    },
    editRow(item) {
      this.openToEdit = true;
      this.itemId = item.id;
    },
    viewRow(item) {
      this.openToView = true;
      this.itemId = item.id;
    },
    setItemID(id) {
      if (id) return this.editRow({ id });

      this.itemId = null;
      this.onCloseDialog();
    },
    changeLanguage(language) {
      this.options.language = language;
    },
    getData() {
      this.$store.commit('loading/SET_SHOW', true);

      const requestConfig = {
        params: {
          skipCount: this.skipPerPage,
          maxResultCount: this.options.pageSize,
          language: this.options.language,
          categoryName: this.options.categoryName,
        },
        paramsSerializer: function (params) {
          const queryString = qs.stringify(params, { arrayFormat: 'brackets' });
          return queryString;
        },
      };

      this.$http
        .get('app/category/by-filters', requestConfig)
        .then((response) => {
          const { items, totalCount } = response.data;

          const resultData = items.reduce((p, c) => {
            const language = c.categoryLanguages[0];
            const parentLanguage = c.parent?.categoryLanguages[0];
            const contentTypeLanguage = c.contentType?.contentTypeLanguages[0];
            const data = [
              ...p,
              { ...c, language, parentLanguage, contentTypeLanguage },
            ];
            return data;
          }, []);

          this.category = resultData;
          this.total = totalCount;
        })
        .catch((error) => {
          showSnackbarFailMessage('حدث خطأ اثناء عملية جلب البيانات');
        })
        .finally(() => this.$store.commit('loading/SET_SHOW', false));
    },
    searchUser() {},
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
    'filters.categoryName': {
      handler() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(
          () => Object.assign(this.options, this.filters),
          500,
        );
      },
    },
  },
};
</script>
